import Swiper, { Navigation } from 'swiper';

Swiper.use([Navigation]);

const updateSlideFocus = (swiper) => {
    swiper.el.querySelectorAll('.swiper-slide').forEach((slide, index) => {
        if (index === swiper.activeIndex) {
            slide.removeAttribute('tabindex');
        } else {
            slide.setAttribute('tabindex', '-1');
        }
    });
};

const initCardMedia = () => {
    document.querySelectorAll('[data-card-media-swiper]').forEach((el) => {
        if (el.swiper) {
            return;
        }

        const media = el.closest('.card-media');

        new Swiper(el, {
            nested: true,
            observer: true,
            observeParents: true,
            navigation: {
                prevEl: media.querySelector('.card-media-prev'),
                nextEl: media.querySelector('.card-media-next'),
            },
            on: {
                slideChange: updateSlideFocus,
            },
        });
    });
};

const previousAfterResultsSuccess = window.afterResultsSuccess;

window.afterResultsSuccess = () => {
    if (previousAfterResultsSuccess) {
        previousAfterResultsSuccess();
    }

    initCardMedia();
};

initCardMedia();
